export default "__VITE_ASSET__DomjrjAl__"